var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Content',{attrs:{"title":"Settings"}},[_c('div',{staticClass:"flex flex-wrap justify-center gap-5"},[_c('SettingsNavigation'),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }